import { Delete, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, ButtonGroup, Card, CardActions, CardContent, Container, Divider, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Slider, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import $carbon, { animalsMassAndNexcretion, pesticideTypes } from "../../../services/$carbon";
import SelectInput from "../../ui/SelectInput";
import { variables } from "../../../styles/abstract/variables";

function IrrigatonForm(props) {
  const { model, setModel, nextStep, prevStep, area } = props;

  const [local, setLocal] = useState({
    fuel: undefined,
    method: undefined,
    volume: undefined,
    // depth: undefined,
    percentage: 100,
  });

  useEffect(() => {
    if(model.records.length > 0) {
      let total = $carbon.calculateIrrigationEmission(model.records, area);
      console.log(total);
      setModel({ totalEmission: total});
    } else {
      setModel({totalEmission: undefined});
    }
  }, [JSON.stringify(model.records)]);

  const renderRecords = () => {
    if (model.records.length === 0) {
      return (
        <Grid item xs={12}>
          <Typography>No records</Typography>
        </Grid>
      )
    }

    return (
      <Grid item xs={12}>
        <List dense>
          {
            model.records.map((record, i) => (
              <ListItem className="co-background" key={i}>
                <ListItemText primary={record.method} secondary={`Power Source: ${record.fuel} | Irrigated Area ${(area*record.percentage/100).toFixed(2)} ha | Irrigation Volume: ${record.volume} m3`} />
                <ListItemSecondaryAction><IconButton onClick={() => setModel({records: model.records.filter((r,j) => j !== i)})} size="small" color="error"><Delete fontSize="small"/></IconButton></ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </List>
      </Grid>
    )

  }

  const renderForm = () => {
    return (
      <>
        <Grid item xs={12} sm={6}>
          <SelectInput name="Power Source" value={local.fuel} items={$carbon.formatIrrigationFuels()} onChange={(e) => { setLocal(current => ({ ...current, fuel: e.target.value })) }} label="Power Source" variant="outlined" fullWidth size="small" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectInput name="Irrigation Method" value={local.method} items={$carbon.formatIrrigationMethods()} onChange={(e) => { setLocal(current => ({ ...current, method: e.target.value })) }} label="Irrigation Method" variant="outlined" fullWidth size="small" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField size="small" value={local.volume} onChange={(e) => setLocal(current => ({ ...current, volume: e.target.value }))} type="number" label={<>Irrigation Volume [m<sup>3</sup>]</>} variant="outlined" fullWidth />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack>
            <span>Percentage of irrigated area (%)</span>
            <Slider value={local.percentage} min={0} max={100} valueLabelDisplay="auto" onChange={(evt, val) => setLocal(current => ({ ...current, percentage: val }))} />
          </Stack>
        </Grid>
        <Grid item xs={12}>
          <Button disabled={!local.fuel || !local.method || !local.volume} onClick={() => setModel({ records: [...model.records, { ...local }] })} variant="contained" >Add record</Button>
        </Grid>
      </>
    )
  }

  const renderContent = () => {
    return (
      <Grid item xs={12}>
        <Card elevation={5} style={{ borderRadius: 0, background: 'transparent' }}>
          <CardContent className="co-background" sx={{ padding: '40px' }}>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} sm={6}>
                <SelectInput name="Category" value={local.category} items={createCategories()} onChange={(e) => {setLocal( current => ({...current, category: e.target.value}))}} label="Category" variant="outlined" fullWidth size="small" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size="small" value={local.numberOfAnimals} onChange={(e) => setLocal(current => ({ ...current, numberOfAnimals: e.target.value }))} type="number" label="Number of animals" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField size="small" value={local.hours} onChange={(e) => setLocal(current => ({ ...current, hours: e.target.value }))} type="number" label="Total hours on the field" variant="outlined" fullWidth />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button disabled={!local.category || !local.numberOfAnimals || !local.hours} onClick={() => setModel({records: [...model.records, {...local}]})} variant="contained" >Add record</Button>
              </Grid>

              <Grid item xs={12}>
                <Divider color="primary" light style={{ background: variables.primary, height: '3px' }} />
              </Grid> */}
              {renderForm()}
              {renderRecords()}
            </Grid>
          </CardContent>
          <CardActions style={{ padding: '0 16px 16px 16px', justifyContent: 'flex-end' }} className="co-background">
            <Button onClick={prevStep} variant="contained" endIcon={<KeyboardArrowLeft />}>Previous</Button>
            <Button onClick={nextStep} variant="contained" endIcon={<KeyboardArrowRight />}>Finalize</Button>
          </CardActions>
        </Card>
      </Grid>
    )
  }

  return (
    <Container>
      <Grid container spacing={2}>
        {renderContent()}
      </Grid>
    </Container>
  );
}

export default IrrigatonForm;